const viewportChecker = require('jquery-viewport-checker');

$('.showMe').viewportChecker({
  classToAdd: '--visible'
});
